import BaseContentDetailsDetailsSubPageView from "scripts/views/baseContentDetailsDetailsSubPageView";
import CitationsView from "scripts/views/citationsView";
import templateContentDetailsArticlePageDetailsSubPage from "templates/contentDetailsArticlePageDetailsSubPage.hbs";

class ContentDetailsArticlePageDetailsSubPageView extends BaseContentDetailsDetailsSubPageView {
  get template() {
    return templateContentDetailsArticlePageDetailsSubPage;
  }

  constructor(options) {
    super(options);

    this.citationsView = this.addSubView(
      new CitationsView({
        mediaId: this.model.get("id"),
      }),
    );
  }

  render() {
    super.render();

    this.citationsView
      .attachTo($("#bb-content-details-citation-region"))
      .fetch()
      .then(() => this.citationsView.render());

    return this;
  }
}

export default ContentDetailsArticlePageDetailsSubPageView;
